/*
 *
 * Apm
 *
 * @version 1.0.0
 * @author Alessandro Mosca
 * @since 10-Gen-2025
 */

// import React from 'react'
// import PortalMessage from 'Hoc/PortalMessage'

import { defineMessages } from 'react-intl'

export const captions = {
  processingRulesTable: {
    id: 't.app.accessibility.subscriptionPlans.processingRulesList.tableCaption',
    defaultMessage: 'Processing rules list'
  }
}

export const processingRules = defineMessages({
  date: {
    id: 't.app.settings.processingRulesTable.table.date',
    defaultMessage: 'Date'
  },
  ruleName: {
    id: 't.app.settings.processingRulesTable.table.ruleName',
    defaultMessage: 'Rule Name'
  },
  ruleType: {
    id: 't.app.settings.processingRulesTable.table.ruleType',
    defaultMessage: 'Rule Type'
  },
  status: {
    id: 't.app.settings.processingRulesTable.table.status',
    defaultMessage: 'Status'
  },
  action: {
    id: 't.app.operationsmanagement.action',
    defaultMessage: 'Action'
  },
  manage: {
    id: 't.app.settings.processingRulesTable.table.editbBtn',
    defaultMessage: 'Manage'
  },
  delete: {
    id: 't.app.settings.processingRulesTable.table.deleteBtn',
    defaultMessage: 'Delete'
  },
  deleteTitle: {
    id: 't.app.settings.popup.processingRules.delete.title',
    defaultMessage: 'Delete Rule'
  },
  deleteDescription: {
    id: 't.app.settings.popup.processingRules.delete.description',
    defaultMessage: 'Are you sure to delete the rule?'
  },
  manageTitle: {
    id: 't.app.settings.popup.processingRules.manage.title',
    defaultMessage: 'Processing Rule'
  },
  confirm: {
    id: 't.app.project.btn.confirm',
    defaultMessage: 'Confirm'
  },
  enable: {
    id: 't.app.settings.processingRulesTable.table.enable',
    defaultMessage: 'Enable'
  },
  ruleSettings: {
    id: 't.app.settings.processingRules.create',
    defaultMessage: 'Rule Settings'
  },
  createNewRule: {
    id: 't.app.settings.popup.processingRules.create.title',
    defaultMessage: 'Create New Rule'
  },
  create: {
    id: 't.app.settings.popup.processingRules.btn.create',
    defaultMessage: 'Create'
  },
  CARD_BIN_BLOCK: {
    id: 't.app.settings.processingRules.form.binBlock',
    defaultMessage: 'Card Bin Block'
  },
  SINGLE_PAN_BLOCK: {
    id: 't.app.settings.processingRules.form.singlePanBlock',
    defaultMessage: 'Single PAN Block'
  },
  MASKED_PAN: {
    id: 't.app.settings.processingRules.form.maskedPan',
    defaultMessage: 'Masked PAN'
  },
  CARD_TYPE: {
    id: 't.app.settings.processingRules.form.cardType',
    defaultMessage: 'Card Type'
  },
  IP_BLOCK: {
    id: 't.app.settings.processingRules.form.ipBlock',
    defaultMessage: 'IP Block'
  },
  CARDHOLDER_BLOCK: {
    id: 't.app.settings.processingRules.form.blockCardHolder',
    defaultMessage: 'Block Card Holder'
  },
  SETTING_AUTO_LOCKOUT_TIMES: {
    id: 't.app.settings.processingRules.form.autoLockout',
    defaultMessage: 'Setting Auto Lockout Times'
  },
  SETTING_DUPLICATE_LOCKOUT_TIMES: {
    id: 't.app.settings.processingRules.form.duplicateLockout',
    defaultMessage: 'Setting Duplicate Lockout Times'
  },
  ENABLED: {
    id: 't.app.settings.processingRules.form.activeRule',
    defaultMessage: 'Enabled'
  },
  DISABLED: {
    id: 't.app.settings.processingRules.form.disabledRule',
    defaultMessage: 'Disabled'
  },
  close: {
    id: 't.app.accessibility.project.btn.close.ariaLabel',
    defaultMessage: 'Close'
  }
})
